import { Store, applyMiddleware, CombinedState } from "redux";
import { legacy_createStore as createStore } from "redux";

// import { omit } from "ramda";
import createSagaMiddleware from "redux-saga";
import { routerMiddleware } from "connected-react-router";
import { composeWithDevTools } from "redux-devtools-extension";
import { History } from "history";
import thunk from "redux-thunk";

import { ApplicationState, createRootReducer, rootSaga } from "./store";
import { configureWithSessionState } from "./repo/api";
import { SessionState } from "./store/session/types";

export const loadState = () => {
  try {
    const serializedState = sessionStorage.getItem("state") || "{}";
    if (!serializedState) {
      return undefined;
    } else {
      const parsedState = JSON.parse(serializedState);
      return parsedState;
    }
  } catch (err) {
    return undefined;
  }
};

export const saveState = (state: ApplicationState) => {
  try {
    const serializedState = JSON.stringify(state);
    sessionStorage.setItem("state", serializedState);
  } catch (err) {
    console.log(err);
  }
};

export default function configureStore(history: History): Store {
  const composeEnhancers = composeWithDevTools({});
  const sagaMiddleware = createSagaMiddleware({
    onError: (err) => console.log(err),
  });
  const persistedState = loadState();
  // const persistedState = {};
  const castedState = persistedState as ApplicationState;
  if (castedState.session) {
    configureWithSessionState(castedState.session);
  }

  const store = createStore(
    createRootReducer(history),
    persistedState,
    composeEnhancers(
      applyMiddleware(routerMiddleware(history), sagaMiddleware, thunk)
    )
  );

  // report errors in saga & restart it
  function keepAlive(sagaFn: () => unknown) {
    return function* () {
      while (true) {
        try {
          const result = yield sagaFn();
          return result;
        } catch (e) {
          if (process.env.ENVIRONMENT === "local") {
            console.error("saga aborted due to:", e);
          }
        }
      }
    };
  }

  sagaMiddleware.run(keepAlive(rootSaga));
  store.subscribe(() => {
    const stateToSave = store.getState();
    saveState(stateToSave as ApplicationState);
  });

  return store;
}
